import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhyStrapInExists from '../components/WhyStrapInExists';
import WhatWeDoDifferently from '../components/WhatWeDoDifferently';
import WhyVerification from '../components/WhyVerification';
import SafetySection from '../components/SafetySection';
import HowItWorks from '../components/HowItWorks';
import DiscoveryModes from '../components/DiscoveryModes';
import HomeCTA from '../components/HomeCTA';
import Footer from '../components/Footer';

function Home() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-onyx text-white">
      <Header />
      <main>
        <Hero />
        <WhyStrapInExists />
        <WhatWeDoDifferently />
        <WhyVerification />
        <SafetySection />
        <HowItWorks />
        <DiscoveryModes />
        <HomeCTA />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
